// export const data = [
//   {
//     title: "1",
//     isRemove: false
//   },
//   {
//     title: "2",
//     isRemove: false
//   },
//   {
//     title: "3",
//     isRemove: false
//   },
//   {
//     title: "4",
//     isRemove: false
//   }
// ];

export const animals = [
  {
    name: "Rhinoceros Hornbill",
    latinName: "Buceros rhinoceros",
    animalType: "Bird",
    activeTime: "Diurnal",
    lengthMin: "3.13",
    lengthMax: "3.46",
    weightMin: "4.5",
    weightMax: "6.5",
    lifespan: "35",
    habitat: "Forest",
    diet: "Fruit and small animals",
    geoRange: "Malay peninsula and Borneo",
    imageLink: "https://upload.wikimedia.org/wikipedia/commons/6/6f/Buceros_rhinoceros_-Singapore_Zoo_-pair-8a.jpg",
    id: 150
  },
  {
    name: "Grey Crowned Crane",
    latinName: "Balearica regulorum",
    animalType: "Bird",
    activeTime: "Diurnal",
    lengthMin: "3.3",
    lengthMax: "3.5",
    weightMin: "6.5",
    weightMax: "8.7",
    lifespan: "25",
    habitat: "Wetlands and grasslands",
    diet: "Grasses, seeds, insects, and other small animals",
    geoRange: "Eastern and southern Africa",
    imageLink: "https://upload.wikimedia.org/wikipedia/commons/5/5f/Grey_crowned_crane_at_Martin_Mere.JPG",
    id: 82
  },
  {
    name: "Aye-aye",
    latinName: "Daubentonia madagascariensis",
    animalType: "Mammal",
    activeTime: "Nocturnal",
    lengthMin: "1",
    lengthMax: "1.3",
    weightMin: "5",
    weightMax: "6",
    lifespan: "23",
    habitat: "Forest and swamp",
    diet: "Insect larva, nuts, and fruits",
    geoRange: "Madagascar",
    imageLink: "https://upload.wikimedia.org/wikipedia/commons/a/a2/Wild_aye_aye.jpg",
    id: 21
  },
  {
    name: "Masai Giraffe",
    latinName: "Giraffa camelopardalis tippelskirchi",
    animalType: "Mammal",
    activeTime: "Diurnal",
    lengthMin: "15",
    lengthMax: "17",
    weightMin: "1200",
    weightMax: "4250",
    lifespan: "13",
    habitat: "Savanna and woodland",
    diet: "Leaves, shoots, and fruits",
    geoRange: "Southern Kenya and Tanzania",
    imageLink: "https://upload.wikimedia.org/wikipedia/commons/3/3b/Mannetjes_masaigiraffe_in_de_Serengeti%2C_Tanzania%2C_-12_januari_2013_a.jpg",
    id: 114
  },
  {
    name: "Saddle-billed Stork",
    latinName: "Ephippiorhynchus senegalensis",
    animalType: "Bird",
    activeTime: "Diurnal",
    lengthMin: "4.75",
    lengthMax: "4.92",
    weightMin: "11",
    weightMax: "16",
    lifespan: "12",
    habitat: "Freshwater marshes, rivers, floodplains and lake shores",
    diet: "Mainly fish, some other small aquatic creatures, insects and carrion",
    geoRange: "Central Africa",
    imageLink: "https://upload.wikimedia.org/wikipedia/commons/e/e6/Saddle-billed_Stork_in_flight.jpg",
    id: 156
  },
  {
    name: "Malayan Tiger",
    latinName: "Panthera tigris jacksoni",
    animalType: "Mammal",
    activeTime: "Nocturnal",
    lengthMin: "7.6",
    lengthMax: "9.3",
    weightMin: "220",
    weightMax: "400",
    lifespan: "15",
    habitat: "Forest",
    diet: "Deer, wild pigs, and cattle",
    geoRange: "Malaysia and southern Thailand",
    imageLink: "https://upload.wikimedia.org/wikipedia/commons/6/62/MalayanTiger01.jpg",
    id: 113
  },
  {
    name: "Timber Rattlesnake",
    latinName: "Crotalus horridus",
    animalType: "Reptile",
    activeTime: "Nocturnal",
    lengthMin: "6",
    lengthMax: "6.3",
    weightMin: "1.1",
    weightMax: "3.3",
    lifespan: "20",
    habitat: "Rocky hillsides, fields, woodlands and swamp",
    diet: "Small mammals, birds, reptiles and amphibians",
    geoRange: "Southeastern United States",
    imageLink: "https://upload.wikimedia.org/wikipedia/commons/f/fc/Adult_Crotalus_horridus.jpg",
    id: 175
  },
  {
    name: "Pascagoula Map Turtle",
    latinName: "Graptemys gibbonsi",
    animalType: "Reptile",
    activeTime: "Diurnal",
    lengthMin: "0.42",
    lengthMax: "0.96",
    weightMin: "0.75",
    weightMax: "6.94",
    lifespan: "40",
    habitat: "Creeks and rivers",
    diet: "Insects, snails, and clams",
    geoRange: "Pascagoula River system, Mississippi ",
    imageLink: "https://upload.wikimedia.org/wikipedia/commons/1/1c/Graptemys.gibbonsi.jpg",
    id: 134
  },
  {
    name: "Fire-bellied newt",
    latinName: "Cynops pyrrhogaster pyrrhogaster",
    animalType: "Amphibian",
    activeTime: "Nocturnal",
    lengthMin: "0.35",
    lengthMax: "0.5",
    weightMin: "0.004",
    weightMax: "0.004",
    lifespan: "25",
    habitat: "Ponds, stream pools and lakes",
    diet: "Aquatic invertebrates",
    geoRange: "Japan",
    imageLink: "https://upload.wikimedia.org/wikipedia/commons/3/3f/Cynops_ensicauda_popei.jpg",
    id: 71
  },
  {
    name: "Fairy Bluebird",
    latinName: "Irena puella",
    animalType: "Bird",
    activeTime: "Diurnal",
    lengthMin: "0.75",
    lengthMax: "0.9",
    weightMin: "0.03",
    weightMax: "0.18",
    lifespan: "12",
    habitat: "Forest",
    diet: "Fruit, nectar, and insects",
    geoRange: "South and Southeast Asia",
    imageLink: "https://upload.wikimedia.org/wikipedia/commons/3/3f/Fairy_bluebird_male_-_Irena_puella.jpg",
    id: 69
  }
]
